export default "__VITE_ASSET__DgYr$IaQ__"